export const INVOCATION_THRESHOLD = 10;

export const INVOCATIONS_SELECTED_TOOL_COOKIE = 'build_cache_invocations_selected_tool';

// One-time "you can set up Build Cache locally" product tour (ACI-5306). Eligibility is decided
// server-side and arrives as the shouldShowLocalSetupTour page prop.
// Mirrors NotificationsController::LOCAL_BUILD_CACHE_SETUP_TOUR.
export const LOCAL_SETUP_TOUR_NOTIFICATION_NAME = 'local-build-cache-setup-tour';
// The "Setting up in a local dev environment" section is added by bitrise-io/docs#173; until that
// merges the anchor is a no-op and the link still lands on the getting started page.
export const LOCAL_SETUP_TOUR_DOCS_URL =
  'https://docs.bitrise.io/en/bitrise-build-cache/getting-started-with-the-build-cache/getting-started-with-the-build-cache#setting-up-in-a-local-dev-environment';

// Mirrors the invocation list defaults of components/bff/app/controllers/build_cache/invocations_controller.rb
export const DEFAULT_ITEMS_PER_PAGE = 10;
export const MAX_ITEMS_PER_PAGE = 100;
